import styled, { keyframes } from 'styled-components';

const slideDown = keyframes`
  from { transform: translateY(-100%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

export const Banner = styled.div`
  position: fixed;
  top: 60px;
  left: 12px;
  right: 12px;
  z-index: 15;
  background: ${({ theme }) => theme.colors['primary-60']};
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  animation: ${slideDown} 300ms cubic-bezier(0.2, 0.8, 0.4, 1);
  box-shadow: 0 8px 24px hsla(0, 0%, 0%, 0.16);
`;

export const Message = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
`;

export const RefreshButton = styled.button`
  padding: 6px 14px;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
  -webkit-tap-highlight-color: transparent;
  white-space: nowrap;

  &:active {
    background: rgba(255, 255, 255, 0.3);
  }
`;
